"use client";

import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { usePageTitle } from "@/lib/usePageTitle";

const lastUpdated = "January 19, 2026";

export default function CookiePolicyPage() {
  usePageTitle("Cookie Policy");
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1 px-4 py-12 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl space-y-6">
          <div className="space-y-2">
            <h1 className="text-3xl font-bold tracking-tight">Cookie policy</h1>
            <p className="text-sm text-muted-foreground">Last updated: {lastUpdated}</p>
          </div>
          <div className="space-y-5 text-muted-foreground">
            <p>
              This Cookie Policy explains how BlockyNetworks uses cookies and similar technologies. Cookies are small text
              files stored on your device. We use them to keep the platform running, remember your preferences, and measure
              performance.
            </p>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Cookie categories</h2>
              <ul className="mt-2 list-disc space-y-2 pl-5">
                <li>
                  <span className="font-medium text-foreground">Essential:</span> Required to operate the platform, keep you
                  signed in, and protect accounts.
                </li>
                <li>
                  <span className="font-medium text-foreground">Performance:</span> Helps us understand how the platform is
                  used so we can improve it. These are optional.
                </li>
                <li>
                  <span className="font-medium text-foreground">Functional:</span> Remembers preferences like language or
                  region. These are optional.
                </li>
              </ul>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Managing cookies</h2>
              <p className="mt-2">
                You can accept or decline non-essential cookies using the cookie banner. You can also control cookies in
                your browser settings, but blocking essential cookies may prevent parts of the platform from working.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Third-party services</h2>
              <p className="mt-2">
                We use trusted providers for authentication, analytics, hosting, and monitoring. These providers may set
                their own cookies when you use the platform.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Contact</h2>
              <p className="mt-2">For questions about cookies, contact us at support@blockynetworks.com.</p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
